export const USER_PROFILE_DELETE_COMMAND = 'DELETE';
